import React from "react";

export const BreweryModalContext = React.createContext(null);

export default BreweryModalContext;
